<template>
  <div>
    <div class="text-center mt-8 mb-6">
      <v-img
        src="@/assets/img/favicon-96x96.png"
        class="my-2"
        contain
        height="144"
      />
      <h1 class="display-2 font-weight-bold">
        Cobb Egg Picker
      </h1>
    </div>
      <v-col class="d-flex justify-center">
        <v-card v-show="!userAuthorized" max-width="420px" color="accent">
          <v-card-title>
            Not Authorized
          </v-card-title>
          <v-card-text class="subtitle-1">
          <b>{{ (userProfile?userProfile.displayName : '') }}</b>
          is unauthorized for this application.
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-show="userAuthorized && settings.currentFarm == null">
        <v-btn
          x-large
          color="secondary"
          block
          class="white--text"
          @click="gotoSettings()"
        >
          <v-icon>mdi-cog</v-icon><div>Click here to set farm</div>
        </v-btn>
      </v-col>
    <v-row class="mx-1" justify="space-around">
      <v-col v-if="settings.currentFarm != null">
        <v-btn
          x-large
          color="tertiary"
          block
          class="white--text"
          @click="$router.push('EggGroups')"
        >
          <v-icon>mdi-egg</v-icon>
          <div class="pl-1 pt-1">Egg Collection</div>
        </v-btn>
      </v-col>
      <v-col v-if="settings.currentFarm != null">
        <v-btn
          x-large
          color="secondary"
          block
          class="white--text"
          @click="$router.push('EggVision')"
        >
          <v-icon>mdi-camera</v-icon>
          <div class="pl-1 pt-1">Egg Vision</div>
        </v-btn>
      </v-col>
    </v-row>
    <v-overlay :value="isBusy">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>

import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      userAuthorized: true,
      isBusy: false
    }
  },
  computed: {
    ...mapState(['settings', 'isAuthenticated', 'isOnline', 'userProfile'])
  },
  async created() {
    try {
      this.isBusy = true;
      if (this.isOnline && this.isAuthenticated) {
        try {
          await this.loadFarmSettingsFromServer(this.settings);
        }
        catch (e) {
          console.log(this.userProfile); // eslint-disable-line no-console
          if (e.toString().indexOf("User not authorized") !== -1) {
            this.userAuthorized = false;
          }
          else throw e;
        }

      }
    }
    finally {
      this.isBusy = false;
    }
   
  }, 
  methods: {
    ...mapActions(['loadFarmSettingsFromServer']),
    gotoSettings() {
      this.$router.replace({ name: 'Settings'});
    }
  }
}
</script>